import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getProvinsi = 'provinsi';
const postProvinsiUrl = 'provinsi';
const putProvinsi = 'provinsi/';
const deleteProvinsi = 'provinsi/';

class ProvinsiService {
    getProvinsi(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getProvinsi + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter,
            {
                headers: authHeader()
            });
    }

    getAllProvinsi() {
        return axios.get(
            API_URL + getProvinsi + '?pageNo=0&pageSize=300&filter=default',
            {
                headers: authHeader()
            });
    }

    postProvinsi(formData) {        
        return axios
        .post(
            API_URL + postProvinsiUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putProvinsi(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putProvinsi + formData.idProvinsi, formData,
            { headers: authHeader() }
        );
    }

    deleteProvinsi(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteProvinsi + formData.idProvinsi,
                { headers: authHeader() }
            );
    }

}

export default new ProvinsiService();